var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogAddLaw__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("יצירת תרגול חדש מתרגול חשיפה"),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "DialogAddLaw__Component__Loading" },
          [
            _c(
              "b-field",
              { attrs: { label: "הזן שם לתרגול" } },
              [
                _c("b-input", {
                  model: {
                    value: _vm.model.ExerciseName,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "ExerciseName", $$v)
                    },
                    expression: "model.ExerciseName",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "יחידת לימוד" } },
              [
                _c("FieldInlineSelect", {
                  attrs: {
                    label: "",
                    filterable: true,
                    clearable: true,
                    optionsAsync: _vm.getLessons,
                  },
                  model: {
                    value: _vm.model.ToLessonId,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "ToLessonId", $$v)
                    },
                    expression: "model.ToLessonId",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              label: "שמור",
              type: "is-primary",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }